import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {SaleRetrocessionModel} from '../../../api/entity/saleRetrocession.model';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {SaleRetrocessionConverter} from '../../../api/entity/converter/saleRetrocession.converter';


@Injectable()
export class SaleRetrocessionDataService extends AbstractDataServiceV2<SaleRetrocessionModel, SaleRetrocessionConverter > {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger,
                config: DefaultDataServiceConfig,
                converter: SaleRetrocessionConverter) {
        super('SaleRetrocession', http, httpUrlGenerator, logger, config, converter);
    }
}
